import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faQuestion, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useState } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { ButtonTypes } from "../../models/ButtonTypes";
import { DialogContext } from "./DialogContext";

export interface DialogContent {
    message: string;
    title: string;
    buttons?: DialogButton[]
}

export interface DialogButton {
    id: string,
    text: string,
    onClick: () => void,
    type: ButtonTypes,
    className?: string
}

const Dialog: FC = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [dialogContent, setDialogContent] = useState<DialogContent>({
        message: '',
        title: '',
        buttons: []
    });
    const { translate } = useLocale();

    const pushError = (dialogContent: DialogContent) => {
        setOpen(true);
        setDialogContent(dialogContent);
    }

    const pushInfo = (dialogContent: DialogContent) => {
        setOpen(true);
        setDialogContent(dialogContent);
    }

    const onButtonClicked = (onCliked: () => void) => {
        onCliked();
        setOpen(false);
    }

    return <DialogContext.Provider value={{ pushError, pushInfo }}>
        <Modal
            isOpen={open}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-50 bg-black z-50"
            className="bg-white border-none m-auto shadow select-none outline-none  rounded-md">
            <div className="py-3 px-4 flex flex-col" style={{ width: '400px' }} >
                <div className="text-lg font-bold px-3">{dialogContent.title}</div>
                <p className="flex text-black break-normal text-base mb-3 px-3 py-2" id='dialogueMessage'>
                    {dialogContent.message}
                </p>

                <div className="flex flex-row-reverse">
                    {dialogContent.buttons && dialogContent.buttons.length > 0 ?
                        dialogContent.buttons?.map((button) => {
                            return <button
                                id={button.id}
                                onClick={() => onButtonClicked(button.onClick)}
                                type="button"
                                className={`${button.type} ${button.className ? button.className : 'ml-2 mr-2 text-base font-medium'}`}>
                                {button.text}
                            </button>
                        }) :
                        <button
                            onClick={() => setOpen(false)}
                            type="button"
                            id='dialogueOkBtn'
                            className={`${ButtonTypes.BlueRoundedButton} bg-portal-blue-primary-shade2`}>
                            {translate.byKey(TranslationKeys.ok)}
                        </button>}
                </div>
            </div>
        </Modal>
        {children}
    </DialogContext.Provider>
}

export default Dialog;